import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './CompanyCertificatesPopup.css';
import countries from '../../pages/v2/jsons/countries.json';

const TextInfo = ({ isOpen, onClose, text, returnFocusRef }) => {
  const { t, i18n } = useTranslation();

  const lang = (i18n.language || "en").split("-")[0].toLowerCase();
  const dialogRef = useRef(null);
  const previousActiveElementRef = useRef(null);

  const getLangFromCountryCode = (countryCode) => {
    const c = countries.find((x) => x.code === countryCode);
    return (c?.lang || "").toLowerCase();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (isOpen) previousActiveElementRef.current = document.activeElement;
    if (isOpen && !dialog.open) dialog.showModal();
    if (!isOpen && dialog.open) dialog.close();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    dialogRef.current?.querySelector("button")?.focus();
  }, [isOpen]);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      handleClose();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = dialogRef.current?.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
    if (!focusable?.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const handleClose = () => {
    onClose();
    requestAnimationFrame(() => (returnFocusRef?.current || previousActiveElementRef.current)?.focus?.());
  };

  if (!isOpen) return null;

  const match =
    text.find((item) => getLangFromCountryCode(item.language) === lang) ||
    text.find((item) => getLangFromCountryCode(item.language) === "en") ||
    text[0];

  return (
    <dialog ref={dialogRef} className="company-certificates-overlay" onClick={handleOverlayClick} onCancel={handleClose} onKeyDown={handleKeyDown} aria-labelledby="text-info-title">
      <div className="company-certificates-popup textinfo">
        <div className="popup-header textinfo">
          <div className="popup-title-sectiontextinfo">
            <div id="text-info-title" className="popup-main-titletextinfo">{t("textInfo")}</div>
          </div>
          <button type="button" className="popup-close-btntextinfo" onClick={handleClose} aria-label={t("close")}>
            <img src="/images/close-icon.svg" alt={t("close")} />
          </button>
        </div>
        <div className="popup-content textinfo">
          {match?.description ?? ""}
        </div>
      </div>
    </dialog>
  );
};

export default TextInfo;
